import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';

const GEOLOCATION_ERRORS = {
  'errors.location.unsupportedBrowser':
    'Browser does not support location services',
  'errors.location.permissionDenied':
    'You have rejected access to your location',
  'errors.location.positionUnavailable': 'Unable to determine your location',
  'errors.location.timeout': 'Service timeout has been reached',
};
@Injectable()
export class GeolocationProvider {
  getLocation(opts): Observable<any> {
    return Observable.create(observer => {
      if (window.navigator && window.navigator.geolocation) {
        window.navigator.geolocation.getCurrentPosition(
          position => {
            observer.next(position);
            observer.complete();
          },
          error => {
            console.log(error);
            switch (error.code) {
              case 1:
                observer.error(
                  GEOLOCATION_ERRORS['errors.location.permissionDenied'],
                );
                break;
              case 2:
                observer.error(
                  GEOLOCATION_ERRORS['errors.location.positionUnavailable'],
                );
                break;
              case 3:
                observer.error(GEOLOCATION_ERRORS['errors.location.timeout']);
                break;
            }
          },
          opts,
        );
      } else {
        observer.error(
          GEOLOCATION_ERRORS['errors.location.unsupportedBrowser'],
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/geolocation/geolocation.ts